var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnibussLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003f80;}.cls-2{fill:#979797;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_pos_rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.87,220.13c-1.8,7.78-9.56,14.09-17.35,14.09s-12.63-6.31-10.84-14.09S356.25,206,364,206s12.63,6.31,10.85,14.09",
    transform: "translate(-139 -182)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.21,318.33c12.94,0,25.87-10.58,28.87-23.64s-5-23.64-18-23.64H629.67v0H626a3.65,3.65,0,0,1-3.62-4.76,6.33,6.33,0,0,1,5.82-4.77H653l4.34-18.86H626.16c-12.94,0-25.87,10.59-28.88,23.65s5.05,23.65,18,23.65h10.52v0h4.53a3.65,3.65,0,0,1,3.63,4.75,6.34,6.34,0,0,1-5.83,4.77H591.81a28,28,0,0,0,1.58-4.79c3-13.07-5-23.64-18-23.64H564v0h-3.63a3.65,3.65,0,0,1-3.62-4.76,6.33,6.33,0,0,1,5.82-4.77h24.77l4.34-18.86H560.47c-12.94,0-25.87,10.59-28.89,23.65s5,23.65,18,23.65H560.1v0h4.52a3.65,3.65,0,0,1,3.62,4.75,6.31,6.31,0,0,1-5.82,4.77H524l-4.35,18.85Z",
    transform: "translate(-139 -182)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.35 61.47 231.71 61.47 215.95 135.6 186.59 135.6 202.35 61.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.18,243.47h44.05c16,0,22.38,6.77,19.74,19.2-1.53,7.19-5.86,13.55-17.39,16.12l-.05.2c11.08,1.54,13.91,9.45,12.23,17.35-2.7,12.74-14.48,21.26-33,21.26H365.42Zm15.12,58.32h4.11c7.19,0,10.56-2.37,11.72-7.81,1-4.51-2.07-6.67-8.95-6.67h-3.8Zm9-42.51-3,14.07h3.9c6.78,0,9.59-3.08,10.5-7.4,1.05-4.92-1.76-6.67-7.61-6.67Z",
    transform: "translate(-139 -182)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.46,292.75c-3.8,17.87-18.54,26.8-40.92,26.8s-33.32-8.93-29.52-26.8l10.48-49.28h29.36l-10.21,48c-1.25,5.85,1.05,8.11,4.13,8.11s6.33-2.26,7.57-8.11l10.21-48h29.37Z",
    transform: "translate(-139 -182)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.53,255.64l-13.2,62H270.8l6.76-31.75c3.27,8.28,9.23,23.32,9.23,23.32,3,7.61,6.42,10.19,13.67,10.19,9.2,0,15.44-4.56,17.13-12.5l13.47-63.45H304.6s-4.88,22.95-7,32.8L288,250.19c-2.09-5.51-6.41-8.3-12.85-8.3-9.32,0-15.72,5-17.58,13.75",
    transform: "translate(-139 -182)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.2,243.47l-10.21,48c-1.25,5.85-4.5,8.11-7.58,8.11s-5.37-2.26-4.13-8.11l10.22-48H169.34l-3.92,18.82h9.71l-6.47,30.46c-3.8,17.87,7.13,26.8,29.52,26.8s37.11-8.93,40.91-26.8l10.48-49.28Z",
    transform: "translate(-139 -182)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 26,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 524,
    y: 139,
    width: 26,
    height: 24
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnibussLogo);
export default __webpack_public_path__ + "static/media/unibuss_logo.326452af3e6395682955e991441071b7.svg";
export { ForwardRef as ReactComponent };